import { Message } from 'element-ui'
import i18n from '@/lang'

export function notifyError(message, isCustom = false) {
  const formattedMessage = isCustom ? message : i18n.t(`errorMsg.${message}`)
  Message.error({
    message: message ? formattedMessage : i18n.t('errorMsg.default')
  })
}
export function notifySuccess(message, isCustom = false) {
  const formattedMessage = isCustom ? message : i18n.t(`successMsg.${message}`)
  Message.success({
    message: message ? formattedMessage : i18n.t('successMsg.default')
  })
}
